export const accordionSx = {
    "& > *": { whiteSpace: "nowrap" },
    pr: 0,
    mr: 0,
    overflow: "visible",
    width: 1,
}
export const indexSx = {
    minWidth: 22,
    whiteSpace: "normal",
}
export const textSx = {
    wordBreak: "break-word",
    minWidth: 100,
    width: 1,
}
export const editorSx = {
    fontSize: "80%",
    color: "text.secondary",
    mt: 0.5,
    ml: 2,
}
export const childWhitespaceSx = { "& > *": { whiteSpace: "normal" } }
export const mobileSx = { ml: -2 }
export const wrapSx = { flexWrap: "wrap" }
